import { useQueryClient, useMutation } from "@tanstack/react-query";
import { http } from "../../../utils";

async function addInquiryAnswer(formData) {
  const data = await http(`/admin/inquiry-answer`, {
    data: formData,
  });
  return data;
}

export function useAddInquiryAnswer() {
  const queryClient = useQueryClient();

  return useMutation(addInquiryAnswer, {
    onSuccess: () => {
      queryClient.refetchQueries(["inquiry-detail"]);
    },
  });
}
